import Loader from 'react-loaders'
import './index.scss'
import {
  SiAmazonaws,
  SiAndroid,
  SiApachekafka,
  SiApachemaven,
  SiBitbucket,
  SiBitrise,
  SiCapacitor,
  SiDocker,
  SiElasticsearch,
  SiExpress,
  SiFastapi,
  SiFirebase,
  SiGraphql,
  SiHibernate,
  SiJest,
  SiMicrosoftsqlserver,
  SiMongodb,
  SiMui,
  SiNestjs,
  SiNextdotjs,
  SiNginx,
  SiNodedotjs,
  SiOpenai,
  SiOpenjdk,
  SiPostgresql,
  SiPrisma,
  SiPython,
  SiRabbitmq,
  SiReacthookform,
  SiRedis,
  SiRedux,
  SiSocketdotio,
  SiSonarcloud,
  SiSpringboot,
  SiStorybook,
  SiSwagger,
  SiSwift,
  SiTailwindcss,
  SiTestinglibrary,
  SiTypescript,
} from 'react-icons/si'
import cv from '../../assets/cv/Youssef Tarek - Full Stack Software Engineer Resume.pdf'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCss3,
  faGitAlt,
  faGithubSquare,
  faHtml5,
  faJsSquare,
  faReact,
  faSass,
} from '@fortawesome/free-brands-svg-icons'

const Skills = () => {
  return (
    <>
      <div className="container skills">
        <div className="text-zone">
          <h1 aria-label="Skills &amp; Experience" className="blast-root">
            <span className="blast" aria-hidden="true" style={{ opacity: '1' }}>
              Skills
            </span>
            <span className="blast" aria-hidden="true" style={{ opacity: '1' }}>
              &amp;
            </span>
            <span className="blast" aria-hidden="true" style={{ opacity: '1' }}>
              Experience
            </span>
          </h1>
          <p>
            Full Stack Software Engineer — technical skills and tooling:
            <br />
            <br />
            <span className="tech-tag">
              <span className="skill-title">Frontend: </span>
              React.js, Next.js, React Native, TypeScript, JavaScript (ES6+),
              Redux Toolkit, Material UI, Tailwind CSS, shadcn/ui, HTML5, CSS3,
              SASS/SCSS, Storybook, React Hook Form, Formik, Axios, RTL,
              Internationalization (i18n)
              <br />
              <br />
              <span className="skill-title">Backend: </span>
              Java 17/21, Spring Boot, Spring Security, Spring Data JPA,
              Hibernate, Maven, Node.js, Express.js, NestJS, Python, FastAPI,
              REST APIs, GraphQL, Swagger/OpenAPI
              <br />
              <br />
              <span className="skill-title">Databases &amp; Storage: </span>
              Microsoft SQL Server, PostgreSQL, MongoDB, Redis, Elasticsearch,
              MinIO, AWS S3, JPA/Hibernate, Prisma, Drizzle ORM, Liquibase,
              Alembic
              <br />
              <br />
              <span className="skill-title">
                Security &amp; Authentication:{' '}
              </span>
              Spring Security, JWT, SAML2 / SSO, Firebase Authentication, RBAC,
              Multi-Tenant Authorization, Biometric Authentication, Android
              Keystore, iOS Keychain, Jasypt, reCAPTCHA v3, API Rate Limiting,
              Helmet, Input Validation
              <br />
              <br />
              <span className="skill-title">
                Architecture &amp; System Design:{' '}
              </span>
              Microservices, Backend-for-Frontend (BFF), Event-Driven
              Architecture, Multi-Tenancy, Clean Architecture, SOLID, Design
              Patterns, Distributed Systems, Real-Time Systems, System Design,
              API Design
              <br />
              <br />
              <span className="skill-title">AI / LLM / Automation: </span>
              AWS Bedrock, Bedrock AgentCore, AI Agents, Agentic Tool Calling,
              RAG, Knowledge Bases, Vercel AI SDK, OpenAI API, Anthropic, LLM
              Streaming, Code Interpreter, AI Document Processing, OCR, NLP
              Workflows, Langfuse, OpenTelemetry
              <br />
              <br />
              <span className="skill-title">AWS / Cloud: </span>
              AWS Bedrock, Bedrock AgentCore, S3, Amazon Transcribe Streaming,
              Amazon Polly, IAM, SigV4, Pre-Signed URLs
              <br />
              <br />
              <span className="skill-title">Mobile &amp; Cross-Platform: </span>
              Android / Java, Android SDK, iOS / Swift, UIKit, WKWebView,
              Capacitor, React Native, PWA, TWA, App Links, Deep Linking,
              Firebase Cloud Messaging, APNs, Biometric Authentication, Google
              Play, App Store, Bitrise
              <br />
              <br />
              <span className="skill-title">Messaging &amp; Real-Time: </span>
              RabbitMQ, Spring AMQP, WebSockets, Socket.IO, Netty-SocketIO,
              Firebase Cloud Messaging, Firebase Admin SDK, Web Push, Service
              Workers, Kafka
              <br />
              <br />
              <span className="skill-title">DevOps &amp; Infrastructure: </span>
              Docker, Docker Compose, Nginx, Linux, CI/CD, Bitbucket Pipelines,
              Bitrise, Git, GitHub, Bitbucket, WildFly, SonarCloud, JaCoCo, AWS,
              Contabo
              <br />
              <br />
              <span className="skill-title">Testing &amp; Quality: </span>
              JUnit 5, Mockito, Awaitility, GreenMail, H2, Jest, React Testing
              Library, MSW, SonarCloud, JaCoCo
              <br />
              <br />
              <span className="skill-title">Engineering Practices: </span>
              Agile/Scrum, Code Review, Debugging, Performance Optimization,
              Production Support, Database Migrations, Observability, Technical
              Documentation
            </span>
          </p>
          <p>
            Full Stack Software Engineer with 4+ years of experience building
            scalable SaaS platforms, enterprise systems, AI-powered
            applications, and cross-platform mobile products. Experienced in
            owning products end-to-end — from requirements and system design
            through frontend, backend, cloud infrastructure, testing, and
            production deployment. Strong expertise across React, Next.js,
            Node.js, NestJS, Java, Spring Boot, and Python/FastAPI, with
            hands-on experience designing microservices, Backend-for-Frontend
            (BFF) architectures, event-driven systems, multi-tenant platforms,
            real-time applications, and AI/LLM agent systems.
          </p>
          <p>
            Visit my
            <a
              target="_blank"
              href="https://linkedin.com/in/youssefTarek-dev"
              rel="noreferrer"
            >
              LinkedIn
            </a>
            profile for more details. Also you can checkout my cv on this
            <a target="_blank" href={cv} rel="noreferrer">
              Link
            </a>
          </p>
        </div>
        <div className="skills-container">
          <div className="skills-icons">
            <div className="icon">
              <FontAwesomeIcon icon={faHtml5} color="#F06529" />
            </div>
            <div className="icon">
              <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
            </div>
            <div className="icon">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="icon">
              <SiTypescript color="#007acc" />
            </div>
            <div className="icon">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="icon">
              <SiNextdotjs color="#000000" />
            </div>
            <div className="icon">
              <SiRedux color="#764ABC" />
            </div>
            <div className="icon">
              <SiReacthookform color="#f50c95" />
            </div>
            <div className="icon">
              <SiOpenjdk color="#f89820" />
            </div>
            <div className="icon">
              <SiSpringboot color="#6DB33F" />
            </div>
            <div className="icon">
              <SiHibernate color="#BCAE79" />
            </div>
            <div className="icon">
              <SiApachemaven color="#C71A36" />
            </div>
            <div className="icon">
              <SiNodedotjs color="#68A063" />
            </div>
            <div className="icon">
              <SiNestjs color="#E0234E" />
            </div>
            <div className="icon">
              <SiExpress color="#000000" />
            </div>
            <div className="icon">
              <SiPython color="#3776AB" />
            </div>
            <div className="icon">
              <SiFastapi color="#009688" />
            </div>
            <div className="icon">
              <SiGraphql color="#E10098" />
            </div>
            <div className="icon">
              <SiSwagger color="#85EA2D" />
            </div>
            <div className="icon">
              <SiMicrosoftsqlserver color="#CC2927" />
            </div>
            <div className="icon">
              <SiPostgresql color="#336791" />
            </div>
            <div className="icon">
              <SiMongodb color="#47A248" />
            </div>
            <div className="icon">
              <SiRedis color="#DC382D" />
            </div>
            <div className="icon">
              <SiElasticsearch color="#005571" />
            </div>
            <div className="icon">
              <SiPrisma color="#7B8CDE" />
            </div>
            <div className="icon">
              <SiRabbitmq color="#FF6600" />
            </div>
            <div className="icon">
              <SiApachekafka color="#FFFFFF" />
            </div>
            <div className="icon">
              <SiSocketdotio color="#010101" />
            </div>
            <div className="icon">
              <SiFirebase color="#FFCA28" />
            </div>
            <div className="icon">
              <SiAmazonaws color="#FF9900" />
            </div>
            <div className="icon">
              <SiOpenai color="#412991" />
            </div>
            <div className="icon">
              <SiAndroid color="#3DDC84" />
            </div>
            <div className="icon">
              <SiSwift color="#F05138" />
            </div>
            <div className="icon">
              <SiCapacitor color="#119EFF" />
            </div>
            <div className="icon">
              <SiTailwindcss color="#28A4D9" />
            </div>
            <div className="icon">
              <SiMui color="rgb(12 33 152)" />
            </div>
            <div className="icon">
              <FontAwesomeIcon icon={faSass} color="#c69" />
            </div>
            <div className="icon">
              <SiStorybook color="#FF4785" />
            </div>
            <div className="icon">
              <SiDocker color="#2496ed" />
            </div>
            <div className="icon">
              <SiNginx color="#009639" />
            </div>
            <div className="icon">
              <SiTestinglibrary color="#e53935" />
            </div>
            <div className="icon">
              <SiJest color="#C21325" />
            </div>
            <div className="icon">
              <SiSonarcloud color="#F3702A" />
            </div>
            <div className="icon">
              <SiBitbucket color="#1d5ecd" />
            </div>
            <div className="icon">
              <SiBitrise color="#68387C" />
            </div>
            <div className="icon">
              <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
            </div>
            <div className="icon">
              <FontAwesomeIcon icon={faGithubSquare} color="#000000 " />
            </div>
          </div>
        </div>
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default Skills
